/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
import perfis from "../config/perfis";
export default [
  {
    path: '',
    name: 'Apresentação',
    view: 'PainelApresentacao'
  },
  {
    path: '/sobre',
    name: 'Sobre',
    view: 'PainelApresentacao'
  },
  {
    path: '/home',
    name: 'Home',
    view: 'PainelApresentacao'
  },
  {
    "path": "/my-projects",
    "name": "Meus Projetos",
    permission: [perfis.LOGADO],
    "view": "PainelProjetosPessoais"
  },
  {
    "path": "/my-unit",
    "name": "Projetos da minha unidade",
    permission: [perfis.LOGADO],
    "view": "PainelProjetosUnidade"
  },
  {
    "path": "/comments",
    "name": "Comentários em projetos",
    permission: [perfis.ADMIN],
    "view": "PainelComentarios"
  },
  {
    "path": "/gerencia",
    "name": "Projetos que realizo gerência",
    permission: [perfis.ADMIN, perfis.GERENTE],
    "view": "PainelProjetosGerente"
  },
  {
    "path": "/projects-ufms-all",
    "name": "Projetos da UFMS (menos AUD/COUN)",
    permission: [perfis.ADMIN],
    "view": "PainelProjetosGeral"
  },
  {
    "path": "/compras-ti",
    "name": "Projetos  de Compras de TIC",
    permission: [perfis.ADMIN, perfis.COMPRAS_TIC],
    "view": "PainelProjetosComprasAGETIC"
  },
  {
    "path": "/uap-inovacao",
    "name": "UAP - Inovação",
    permission: [perfis.ADMIN, perfis.COMPRAS_TIC],
    "view": "PainelProjetosUap"
  },
  {
    "path": "/compras",
    "name": "Projetos  de Compras",
    permission: [perfis.ADMIN, perfis.COMPRAS],
    "view": "PainelProjetosCompras"
  },

  {
    "path": "/icons",
    "name": "Icons",
    "view": "Icons"
  },
  {
    path: '/erro-acesso-negado',
    name: 'Erro Acesso Negado',
    view: 'ErroAcessoNegado'
  },
  {
    path: "/diplan",
    name: "DIPLAN/PROPLAN",
    view: "PainelDiplan",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/prograd",
    name: "PROGRAD",
    view: "PainelPrograd",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/propp",
    name: "PROPP",
    view: "PainelPropp",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/proaes",
    name: "PROAES",
    view: "PainelProaes",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/proece",
    name: "PROECE",
    view: "PainelProece",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/proadi",
    name: "PROADI",
    view: "PainelProadi",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/proplan",
    name: "PROPLAN",
    view: "PainelProplan",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/progrep",
    name: "PROGEP",
    view: "PainelProgep",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/aginova",
    name: "AGINOVA",
    view: "PainelAginova",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/agecom",
    name: "AGECOM",
    view: "PainelAgecom",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/agead",
    name: "AGEAD",
    view: "PainelAgead",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/processos-riscos",
    name: "Painel de Processos e Riscos",
    view: "PainelProcessosRiscos",
    permission: [perfis.LOGADO],
  },
  {
    path: "/cgirci",
    name: "Painel do CGIRCI",
    view: "PainelCgirci",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/jornada/750pontos",
    name: "Painel da Jornada de Excelência 750 Pontos",
    view: "PainelJornada2021",
    permission: [perfis.LOGADO],
  },
  {
    path: "/jornada/500pontos",
    name: "Painel da Jornada de Excelência 500 Pontos",
    view: "PainelJornada2019",
    permission: [perfis.LOGADO],
  },
  {
    path: "/transformagov",
    name: "Painel TransformaGov",
    view: "PainelTransformaGov",
    permission: [perfis.LOGADO],
  },
  {
    path: "/agrotec",
    name: "Painel AGROTEC",
    view: "PainelAgrotec",
    permission: [perfis.LOGADO],
  },
  {
    path: "/mda",
    name: "Painel Apoia MDA",
    view: "PainelMDA",
    permission: [perfis.LOGADO],
  },
  {
    path: "/ufms-digital",
    name: "UFMS Digital",
    view: "PainelUFMSDigital",
    permission: [perfis.LOGADO],
  },
  {
    path: "/obcoop",
    name: "Painel OBCOOP",
    view: "PainelObcoop",
    permission: [perfis.LOGADO],
  },
  {
    path: "/obgov",
    name: "Painel de Observatório Institucional de Governança Pública",
    permission: [perfis.LOGADO],
    view: "PainelObservatorio"
  },
  {
    path: "/visao-estrategica",
    name: "Painel Visão Estrategica",
    permission: [perfis.HOMOLOG],
    view: "PainelVisaoEstrategica"
  },
  {
    path: "/adequacao-lgpd",
    name: "Plano de Adequação LGPD",
    permission: [perfis.LOGADO],
    view: "PainelAdequacaoLGPD"
  },
  {
    path: "/visao-estrategica-uac",
    name: "Painel Visão Estrategica UACs",
    permission: [perfis.HOMOLOG],
    view: "PainelVisaoEstrategicaUAC"
  },
  {
    path: "/auditoria",
    name: "Painel da AUD/COUN",
    view: "PainelAuditoria",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/agetic",
    name: "Painel da AGETIC",
    view: "PainelAgetic",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/pdtic2021",
    name: "Painel do PDTIC 2021-2024",
    view: "PainelPdtic2021",
    permission: [perfis.LOGADO]
  },
  {
    path: "/agetic/pdtic2017",
    name: "Painel do PDTIC 2017-2020",
    view: "PainelPdtic2017",
    permission: [perfis.ADMIN]
  },
  {
    path: "/agetic/contratos",
    name: "Painel de Contratos",
    view: "PainelContratosAgetic",
    permission: [perfis.ADMIN]
  },
  {
    path: "/aprimoramentos-igg",
    name: "Painel de Aprimoramentos IGG",
    view: "PainelMelhoriasIGG",
    permission: [perfis.ADMIN]
  },
  {
    path: "/comite-gestao-pessoas",
    name: "Comitê de Gestão de Pessoas",
    view: "PainelComiteGestaoPessoas",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/comite-governanca-digital",
    name: "Comitê de Governança Digital (GCD)",
    view: "PainelComiteGovernancaDigital",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/comite-governanca-bolsas",
    name: "Comitê de Governança de Bolsas, Auxílios e Retribuição Pecuniária (CGBAR)",
    view: "PainelComiteGovernancaBolsasEtc",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/comite-logistica-sustentavel",
    name: "Comitê de Gestão de Contratações e Logística Sustentável (CGCLOS)",
    view: "PainelComiteLogisticaSustentavel",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/comite-espaco-fisico",
    name: "Comitê de Gestão de Espaços Físicos e Acessibilidade (CGEFA)",
    view: "PainelComiteEspacoFisico",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/comite-inclusao",
    name: "Comitê de Gestão de Inclusão, Internacionalização e Ações Afirmativas (CGIIAF)",
    view: "PainelComiteInclusao",
    permission: [perfis.HOMOLOG],
  },
  {
    path: "/residuos-solidos",
    name: "Plano de Gestão de Resíduos Sólidos (PGRS)",
    view: "PainelResiduosSolidos",
    permission: [perfis.ADMIN]
  },
  {
    path: "/desenvolvimento-pessoas",
    name: "Plano de Desenvolvimento de Pessoas (PDP)",
    view: "PainelDesenvolvimentoPessoas",
    permission: [perfis.ADMIN]
  },
  {
    path: "/bolsas-auxilios",
    name: "Plano de Governança de Bolsas e Auxílios (PGBA)",
    view: "PainelBolsasAuxilios",
    permission: [perfis.ADMIN]
  },
  {
    path: "/internacionalizacao",
    name: "Plano de Internacionalização (PINT)",
    view: "PainelInternacionalizacao",
    permission: [perfis.ADMIN]
  },
  {
    path: "/comunicacao",
    name: "Plano Anual de Comunicação",
    view: "PainelComunicacao",
    permission: [perfis.ADMIN]
  },
  {
    path: "/gestao-logistica-sustentavel",
    name: "Plano de Gestão de Logística Sustentável (PLS)",
    view: "PainelGestaoLogisticaSustentavel",
    permission: [perfis.ADMIN]
  },
  {
    path: "/integridade",
    name: "Plano de Integridade (PGIN)",
    view: "PainelIntegridade",
    permission: [perfis.ADMIN]
  },
  {
    path: "/acessibilidade",
    name: "Plano de Acessibilidade",
    permission: [perfis.LOGADO],
    view: "PainelAcessibilidade",
  },
  {
    path: "/fuga",
    name: "Plano de Fuga - Prevenção contra Incêndios",
    permission: [perfis.LOGADO],
    view: "PainelFuga"
  },
  {
    path: "/dados-abertos",
    name: "Plano de Dados Abertos",
    permission: [perfis.LOGADO],
    view: "PainelDadosAbertos"
  },
  {
    path: "/transicao",
    name: "Plano de Transição de Gestão",
    permission: [perfis.LOGADO],
    view: "PainelTransicaoGestao"
  },
  {
    path: "/contratacoes",
    name: "Plano Anual de Contratações (PAC)",
    permission: [perfis.LOGADO],
    view: "PainelContratacoes"
  },
  {
    path: "/continuidade",
    name: "Plano de Continuidade de Negócios",
    permission: [perfis.LOGADO],
    view: "PainelContinuidade"
  },
  {
    path: "/ocupacao-solo-espacos-fisicos",
    name: "Plano Diretor de Ocupação do Solo e Espaços Físicos",
    permission: [perfis.LOGADO],
    view: "PainelOcupacaoSoloEspacosFisicos"
  },
  {
    path: "/tratamento-de-riscos",
    name: "Painel de Tratamento de Riscos",
    permission: [perfis.LOGADO],
    view: "PainelTratamentoRiscos"
  },
  {
    path: "/agetic/compras",
    name: "Painel de Compras",
    view: "PainelComprasTic",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/infraestruturas",
    name: "Painel de Infraestruturas de TIC",
    view: "PainelInfraTic",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/votacoes",
    name: "Painel de Votações UFMS",
    permission: [perfis.HOMOLOG],
    view: "PainelVotacoes"
  },
  {
    path: "/agetic/projetos-disoft",
    name: "Painel de Projetos DISOFT",
    view: "PainelProjetosDisoft",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/projetos-seds",
    name: "Painel de Projetos SEDS",
    view: "PainelProjetosSeds",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/projetos-dintec",
    name: "Painel de Projetos DINTEC",
    view: "PainelProjetosDintec",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/projetos-secli",
    name: "Painel de Projetos SECLI",
    view: "PainelProjetosSecli",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/projetos-sein",
    name: "Painel de Projetos SEIN",
    view: "PainelProjetosSein",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/projetos-sert",
    name: "Painel de Projetos SERT",
    view: "PainelProjetosSert",
    permission: [perfis.HOMOLOG]
  },
  {
    path: "/agetic/chamados-secli",
    name: "Painel de Chamados SECLI",
    view: "PainelChamadosSecli",
    permission: [perfis.ADMIN]
  },
  {
    path: "/agetic/chamados-sein",
    name: "Painel de Chamados SEIN",
    view: "PainelChamadosSein",
    permission: [perfis.ADMIN]
  },
  {
    path: "/agetic/chamados-sert",
    name: "Painel de Chamados SERT",
    view: "PainelChamadosSert",
    permission: [perfis.ADMIN]
  },
  {
    path: "/agetic/chamados-disoft",
    name: "Painel de Chamados DISOFT",
    view: "PainelChamadosDisoft",
    permission: [perfis.ADMIN]
  },
  {
    path: "/agetic/chamados-fechados",
    name: "Painel de Chamados Fechados Agetic",
    view: "PainelChamadosFechadosAgetic",
    permission: [perfis.ADMIN]
  },
  {
    path: '/ambiente-urls-acesso',
    name: "Acesso de Rotas do Ambiente",
    view: 'PainelMenuRotas',
    permission: [perfis.HOMOLOG]
  },
  {
    path: '/table-list',
    name: 'Table List',
    view: 'TableList'

  },
  {
    path: '/notifications',
    name: 'Notifications',
    view: 'Notifications'
  },
]
